import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import { _post, DeserializeVoid } from '../../../base.service';

@Injectable({
  providedIn: 'root',
})
export class ResetAtelierProgressControllerRequestService {
  private static BASE_URL = '/immo/resetAtelierProgress';
  private readonly post: <T>(
    path: string,
    body: null,
    deserialize: (response: any) => T
  ) => Observable<T>;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      ResetAtelierProgressControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public resetAtelierProgress(subProjectId: number): Promise<void> {
    return this.post(`/${subProjectId}`, null, DeserializeVoid).toPromise();
  }
}
